import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

// SESSION-admin-ptg-003 — Documents tab pill. Backend has 4 server states
// (Pending / Indexing / Indexed / Failed); FE collapses Pending to Indexing…
// (per OQ-6). `Failed` exposes a per-row Retry click that emits `retry`.
export type IndexStatusKind = 'Pending' | 'Indexing' | 'Indexed' | 'Failed';

@Component({
    selector: 'app-index-status-pill',
    templateUrl: './index-status-pill.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class IndexStatusPillComponent {
    @Input() status: IndexStatusKind = 'Pending';
    @Input() failureReason: string | null = null;
    /** SPEC-web-planner-013 AC-87: a read-only viewer sees the Failed state without the Retry action. */
    @Input() readOnly = false;
    @Output() retry = new EventEmitter<void>();

    get visibleKind(): 'Indexing' | 'Indexed' | 'Failed' {
        if (this.status === 'Indexed') {
            return 'Indexed';
        }
        if (this.status === 'Failed') {
            return 'Failed';
        }
        return 'Indexing';
    }

    onRetry(ev: Event): void {
        ev.stopPropagation();
        if (this.readOnly) {
            return;
        }
        this.retry.emit();
    }
}
